import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '@pit/core';
import { IPinItTrackFrontendApplicationService, PinItTrackFrontendServicesAccessor } from '@pit/frontend-shared';

@Component({
    selector: 'pin-it-track-web-app-menu',
    templateUrl: './pin.it.track.web.app.menu.component.html',
    styleUrls: ['./pin.it.track.web.app.menu.component.scss']
})
export class PinItTrackWebAppMenuComponent extends BaseComponent {

    constructor(private readonly servicesAccessor: PinItTrackFrontendServicesAccessor) {
        super(servicesAccessor.coreServicesAccessor.applicationService);

        this.applicationServiceExt = this.servicesAccessor.coreServicesAccessor.applicationService;
    }

    public readonly applicationServiceExt: IPinItTrackFrontendApplicationService = null;

}
